<template>
    <div class="results-facet" aria-live="assertive" v-if="filters && flatFilters && flatFilters.length > 0">
        <button class="clear facet-tag" v-on:click.prevent="resetSearch()">
            <span class="facet-tag__label">Clear all filters</span>
            <span class="facet-tag__remove">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="none" viewBox="0 0 24 24">
                    <path fill="currentColor" d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/>
                </svg>
            </span>
        </button>
        <div class="results-facet__wrapper">
            <span v-for="filter in flatFilters" :key="filter.Id">
                <button class="facet-tag" role="button" v-on:click.prevent="removeFilter(filter.ParentName, filter.Id)">
                    <span class="facet-tag__label">{{filter.Name}}</span>
                    <span class="facet-tag__remove">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="none" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/>
                        </svg>
                    </span>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            filters: {
                get() {
                    return this.$store.state.search.filters
                },
                set() { }
            },

            flatFilters: function () {
                const vm = this

                if (vm.filters) {
                    const flatFilters = []

                    // var selectedFilters = this.searchFilters.FilterList.Filters.map(x => x.FilterTags)

                    Object.keys(vm.filters).forEach(function (x) {
                        if (x.startsWith('filter_')) {
                            Object.keys(vm.filters[x]).filter(y => y.length > 0).forEach(function (y) {
                                var tag = vm.findFilter(vm.filters[x][y])

                                flatFilters.push({
                                    Id: vm.filters[x][y],
                                    Name: tag ? tag.Name : '',
                                    ParentName: x
                                })
                            })
                        }
                    })

                    return flatFilters
                }

                return null
            }
        },

        methods: {
            findFilter: function (filterId) {
                // First, ensure the necessary data structure exists.
                if (this.searchFilters && this.searchFilters.FilterList && this.searchFilters.FilterList.Filters) {
                    // Loop through each main filter category (e.g., "Sectors", "Services").
                    for (const filterGroup of this.searchFilters.FilterList.Filters) {
                        // In each group, try to find the specific tag by its ID.
                        const foundFilterTag = filterGroup.FilterTags.find(tagItem => tagItem.Tag.Id == filterId)

                        // If we found the tag in the current group, return its 'Tag' object immediately.
                        if (foundFilterTag) {
                            return foundFilterTag.Tag
                        }
                    }
                }

                // If the loop completes and nothing was found, return null.
                return null
            },

            removeFilter: function (parent, value) {
                this.$store.dispatch('removeSearchFilter', {
                    parent: parent,
                    value: value
                })

                this.$eventHub.$emit('search-filtersChanged')
            },

            resetSearch: function () {
                this.$store.dispatch('resetSearchFilters')
                this.$store.dispatch('resetSearchResults')
                this.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
                this.$store.dispatch('updateSearchPageCount', 0)
                this.$store.dispatch('updateSearchResultCount', 0)
                this.$store.dispatch('updateSearchResultsLoaded', 0)

                this.$eventHub.$emit('search-filtersChanged')
            }
        },

        props: {
            searchFilters: {
                type: Object
            }
        }
    }
</script>